import { Link } from '@liveauctioneers/hammer-ui-core/link';
import { useLocation } from 'react-router-dom';

import PageTitle from '@/components/PageTitle/PageTitle';
import { useAppSelector } from '@/redux/hooks';
import { getBaseUrl } from '@/redux/modules/config';
import { useAppFormatMessage } from '@/utils/intl/useAppFormatMessage';

const NotFound = () => {
    const baseUrl = useAppSelector(getBaseUrl);
    const { search } = useLocation();
    const formatMessage = useAppFormatMessage();
    const queryParams = new URLSearchParams(search);
    const badUrl = queryParams.get('badUrl');

    return (
        <div className="relative my-2xl flex w-full flex-col items-center justify-center text-center">
            <PageTitle
                className="text-center"
                title="404"
            />
            <p>{formatMessage('sorry_we_cant_find')}</p>
            {Boolean(badUrl) && (
                <p className="mt-0">
                    <i className="text-text-secondary">&quot;{`${baseUrl}${badUrl}`}&quot;</i>
                </p>
            )}
            <p className="mt-0">
                <Link href={baseUrl}>{baseUrl}</Link>
            </p>
        </div>
    );
};

export default NotFound;
